// extracted by mini-css-extract-plugin
export default {"description":"o1Mov2"};